<h1 class="raportti-header" style="margin-top: 20px">ALV-laskelma</h1>
@if (dataObservable | async; as data) {
  @if (!lataa()) {
    <div style="display: flex; justify-content: space-between; align-items: flex-end">
      <div style="font-size: 16px; font-weight: bold; line-height: 24px">{{ (hakuvaihtoehdotObservable | async)?.alkaa | lnumberpvml: 'fi' }} - {{ (hakuvaihtoehdotObservable | async)?.loppuu | lnumberpvml: 'fi' }}</div>
      @if (lastSucessfullyUpdated()) {
        <div class="gray-text" style="font-size: 11px; line-height: 13px">Päivitetty {{ lastSucessfullyUpdated() | ltimestamptime | async }}</div>
      }
    </div>
    <h3 style="margin-top: 2em">Myynnit</h3>
    <!-- <button class="secondarybutton" mat-button (click)="createCsvExportFile()" type="button">Luo OmaVero siirtotiedosto</button> -->
    <table class="report-table" (click)="handleClick($event, data.myynnit, 'myynti')">
      <!-- Note: this is needed to be able to use table-layout: fixed with nth-child(x) selectors for widths. -->
      <thead>
        <tr>
          <th></th>
          <th></th>
          <th>Verollinen</th>
          <th>Veroton</th>
          <th>Vero</th>
        </tr>
      </thead>
      @for (alvData of data.myynnit; track trackAccountRowByAccountNumberFn($index, alvData)) {
        <tbody>
          <tr>
            <td colspan="5" style="font-weight: bold">&nbsp;&nbsp;&nbsp;&nbsp;{{ alvData.n }}</td>
          </tr>
          @for (row of alvData.rivit; track row) {
            <tr [attr.data-tnro]="row.a" [attr.data-vat]="row.alv" class="r">
              <td class="n" style="cursor: pointer">&nbsp;&nbsp;{{ row.n }}</td>
              <td style="width: 20px"></td>
              <td>{{ row.s | number: '1.2-2' }}</td>
              <td>{{ row.b | number: '1.2-2' }}</td>
              <td>{{ row.t | number: '1.2-2' }}</td>
            </tr>
            @if (row.e) {
              <ng-container [ngTemplateOutlet]="laajennusrivi" [ngTemplateOutletContext]="{ $implicit: row }"></ng-container>
            }
          }
          <tr class="r">
            <td class="n">&nbsp;&nbsp;{{ alvData.n }} yhteensä</td>
            <td style="width: 20px"></td>
            <td style="border-top: 1px solid black">{{ alvData.s | number: '1.2-2' }}</td>
            <td style="border-top: 1px solid black">{{ alvData.b | number: '1.2-2' }}</td>
            <td style="border-top: 1px solid black">{{ alvData.t | number: '1.2-2' }}</td>
          </tr>
          <tr class="r">
            <td colspan="5">&nbsp;</td>
          </tr>
        </tbody>
      }
      <tbody>
        <tr>
          <td colspan="5">&nbsp;</td>
        </tr>
        <tr class="r">
          <td class="n" style="font-weight: bold">Myynnit yhteensä</td>
          <td style="width: 20px"></td>
          <td style="font-weight: bold">{{ data.myyntiSums.s | number: '1.2-2' }}</td>
          <td style="font-weight: bold">{{ data.myyntiSums.b | number: '1.2-2' }}</td>
          <td style="font-weight: bold">{{ data.myyntiSums.t | number: '1.2-2' }}</td>
        </tr>
      </tbody>
    </table>
    <h3 style="margin-top: 2em">Ostot</h3>
    <table class="report-table" (click)="handleClick($event, data.ostot, 'osto')">
      <!-- Note: this is needed to be able to use table-layout: fixed with nth-child(x) selectors for widths. -->
      <thead>
        <tr>
          <th></th>
          <th></th>
          <th>Verollinen</th>
          <th>Veroton</th>
          <th>Vero</th>
        </tr>
      </thead>
      @for (alvData of data.ostot; track trackAccountRowByAccountNumberFn($index, alvData)) {
        <tbody>
          <tr>
            <td colspan="5" style="font-weight: bold">&nbsp;&nbsp;&nbsp;&nbsp;{{ alvData.n }}</td>
          </tr>
          @for (row of alvData.rivit; track row) {
            <tr [attr.data-tnro]="row.a" [attr.data-vat]="row.alv" class="r">
              <td class="n" style="cursor: pointer">&nbsp;&nbsp;{{ row.n }}</td>
              <td style="width: 20px"></td>
              <td>{{ row.s | number: '1.2-2' }}</td>
              <td>{{ row.b | number: '1.2-2' }}</td>
              <td>{{ row.t | number: '1.2-2' }}</td>
            </tr>
            @if (row.e) {
              <ng-container [ngTemplateOutlet]="laajennusrivi" [ngTemplateOutletContext]="{ $implicit: row }"></ng-container>
            }
          }
          <tr class="r">
            <td class="n">&nbsp;&nbsp;{{ alvData.n }} yhteensä</td>
            <td style="width: 20px"></td>
            <td style="border-top: 1px solid black">{{ alvData.s | number: '1.2-2' }}</td>
            <td style="border-top: 1px solid black">{{ alvData.b | number: '1.2-2' }}</td>
            <td style="border-top: 1px solid black">{{ alvData.t | number: '1.2-2' }}</td>
          </tr>
          <tr class="r">
            <td colspan="5">&nbsp;</td>
          </tr>
        </tbody>
      }
      <tbody>
        <tr>
          <td colspan="5">&nbsp;</td>
        </tr>
        <tr class="r">
          <td class="n" style="font-weight: bold">Ostot yhteensä</td>
          <td style="width: 20px"></td>
          <td style="font-weight: bold">{{ data.ostoSums.s | number: '1.2-2' }}</td>
          <td style="font-weight: bold">{{ data.ostoSums.b | number: '1.2-2' }}</td>
          <td style="font-weight: bold">{{ data.ostoSums.t | number: '1.2-2' }}</td>
        </tr>
        <tr class="r">
          <td class="n" colspan="4" style="font-weight: bold">Vero yhteensä</td>
          <td style="font-weight: bold">{{ data.myyntiSums.t + data.ostoSums.t | number: '1.2-2' }}</td>
        </tr>
      </tbody>
    </table>
  } @else {
    <mat-spinner style="margin-left: auto; margin-right: auto; margin-top: 20px"></mat-spinner>
  }
}

<ng-template #laajennusrivi let-row>
  <tr>
    <td colspan="5" style="padding-left: 20px">
      @if (row.d1?.length === 0 && row.d2?.length === 0) {
        <div>Tilille ei löytynyt yhtään vientiä.</div>
      }
      <div style="font-weight: bold">Veroton</div>
      @if (row.d1?.length > 0) {
        <ng-container [ngTemplateOutlet]="vientitaulukko" [ngTemplateOutletContext]="{ $implicit: row.d1 }"></ng-container>
      }
      <div style="font-weight: bold">Vero</div>
      @if (row.d2?.length > 0) {
        <ng-container [ngTemplateOutlet]="vientitaulukko" [ngTemplateOutletContext]="{ $implicit: row.d2 }"></ng-container>
      }
      <div style="font-weight: bold">Verollinen yhteensä {{ row.t + row.b | number: '1.2-2' }}</div>
    </td>
  </tr>
</ng-template>

<ng-template #vientitaulukko let-viennit>
  <table style="width: 850px">
    <thead>
      <tr>
        <td>Laji</td>
        <td>Tosite</td>
        <td>Pvm</td>
        <td>Selite</td>
        <td>ALV</td>
        <td>Debet</td>
        <td>Kredit</td>
        <td>Saldo</td>
      </tr>
    </thead>
    <tbody>
      @for (d of viennit; track d; let i = $index) {
        <tr [attr.data-i]="i" [class.laajennettu]="d.l">
          <td [class.projekti-dot]="d.b" [class]="d.b ? 'a' + d.b : null">{{ d.ma }}</td>
          <td [attr.data-n]="d.n" style="cursor: pointer">{{ d.n }}</td>
          <td>{{ d.p | lnumberpvmlnarrow: 'fi' }}</td>
          <td>
            @if (d.a) {
              <span class="blue-text space-after">{{ d.a }}&nbsp;</span>
            }
            @if (d.c) {
              <span class="cursive-text space-after">{{ d.c }}&nbsp;</span>
            }
            {{ d.r }} {{ d.e }}
          </td>
          <td>{{ d.v }}</td>
          <td>{{ d.d | number: '1.2-2' }}</td>
          <td>{{ d.k | number: '1.2-2' }}</td>
          <td>{{ d.s | number: '1.2-2' }}</td>
        </tr>
      }
    </tbody>
  </table>
</ng-template>
